import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import navStore from './modules/navStore';
import matchDetailStore from './modules/matchDetailStore';
import homeListStore from './modules/homeListStore';
import matchListStore from './modules/matchListStore';
import statsListStore from './modules/statsListStore';
import videoListStore from './modules/videoListStore';
import tweetStore from './modules/tweetStore';

Vue.use(Vuex);

export function createStore () {
    return new Vuex.Store({
        state: {
            articlebody: {},
            relative: {},
            comments: {},
            oddsChange: []
        },
        actions,
        mutations,
        getters,
        modules: {
            navStore,
            matchListStore,
            matchDetailStore,
            homeListStore,
            statsListStore,
            videoListStore,
            tweetStore
        }
    });
}



// WEBPACK FOOTER //
// ./src/store/index.js